import _ from "underscore";
import Q from "q";
import get_user_info from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_user_info";
import get_token from "nllib/src/model/get_token";
import aRouter from "../index";
import all_routes_processor from "./all_routes_processor";
import web_common_checkToken from '@/lib/data-service/default/web_common_checkToken';
import redirect_to_login_page from '@/lib/common-service/redirect_to_login_page';

const init_route_guard = function () {
  return ;
  const get_all_route_list = all_routes_processor.get_all_route_list;

  const clear_get_user_info_cache = function (pParameter) {
    if (!pParameter) pParameter = {};
    const to_route = pParameter.to_route;

    if (to_route.name !== `redirect-to-user-front-home`) {
      return Q.resolve();
    }

    return Q.when()
      .then(function () {
        return get_user_info({
          clear_cache: true,
        });
      })
      .catch(function (ex) {
        console.error(ex);
        console.trace();
        if (ex) {
          if (ex.stack) {
            console.error(ex.stack);
          }
        }
        return Q.resolve(ex);
      })
      ;
  };

  aRouter.beforeEach((to, from, next) => {
    try {
      const handler = function () {
        const all_route_list = get_all_route_list();
        const route_name_list_skip_check_token = _.chain(all_route_list)
          .filter(function (m) {
            let flag = false;
            if (m.meta) {
              if (m.meta.skip_check_token) {
                flag = true;
              }
            }
            return flag;
          })
          .map(function (m) {
            return m.name;
          })
          .value()
        ;

        if (_.contains(route_name_list_skip_check_token, to.name)) {
          next();
          return;
        }

        const token = get_token();
        if (!token) {
          redirect_to_login_page();
          return;
        }

        web_common_checkToken().then(
          function () {

            get_user_info().then(
              function (data_get_user_info) {
                //userType
                //1-供应商，2-供应商员工，3-采购商，4-采购商员工， 5-平台， 6-游客（EDI）， 7-临时分销渠道

                //auditStatus
                //分销商
                //0-待审核 1-审核失败 2-部分启用 3-启用 4-平台禁用 5-已删除 6-未签约 7-签约失败

                //auditStatus
                //供应商
                //0-待审核 1-审核失败 2-部分启用 3-启用 4-平台禁用 5-已删除 6-未签约 7-签约失败 8-待设置合同文件

                //供应商，当且仅当【auditStatus】为【0-待审核】、【1-审核失败】、【6-未签约】、【7-签约失败】、【8-待设置合同文件】时，
                //会跳转到分销商的这个项目
                //由于分销商的【auditStatus】与供应商的【auditStatus】的值是一致的，并且值的范围是包含关系的
                //所以，这里不再根据userType进行分支判断

                const auditStatus = data_get_user_info.auditStatus;

                //0-待审核
                if (auditStatus === 0) {
                  aRouter.push({
                    name: `register-success`,
                    query: {
                      type: 1,
                    }
                  });
                  return;
                }

                //1-审核失败
                if (auditStatus === 1) {
                  aRouter.push({
                    name: `audit-message`,
                    query: {}
                  });
                  return;
                }

                //2-部分启用 3-启用
                if (_.contains([2, 3], auditStatus)) {
                  //正常登录
                  next();
                  return;
                }

                //4-平台禁用 5-已删除
                if (_.contains([4, 5], auditStatus)) {
                  //理论上不可能会进入到这里
                  console.error(`auditStatus=${auditStatus}`);
                  return;
                }

                //6-未签约
                if (auditStatus === 6) {
                  aRouter.push({
                    name: `register-success`,
                    query: {
                      type: 3,
                    }
                  });
                  return;
                }

                //7-签约失败
                if (auditStatus === 7) {
                  aRouter.push({
                    name: `register-success`,
                    query: {
                      type: 2,
                    }
                  });
                  return;
                }

                //8-待设置合同文件
                if (auditStatus === 8) {
                  aRouter.push({
                    name: `register-success`,
                    query: {
                      type: 1,
                    }
                  });
                  return;
                }

              },
              function () {
                redirect_to_login_page();
              }
            );

          },
          function (data) {
            redirect_to_login_page();
          },
        );
      };

      clear_get_user_info_cache({to_route: to}).then(function () {
        handler();
      });
    } catch (ex) {
      console.error(ex);
    }

  });

};
export default init_route_guard;
